export const paymentTranslations = {
  lv: {
    settings: 'Iestatījumi',
    title: 'Maksājumi',
    history: 'Maksājumu vēsture',
    empty: 'Maksājumu vēl nav.',
    invoice: 'Rēķins',
    invoiceError: 'Rēķinu neizdevās lejupielādēt.',
    paid: 'Maksājums saņemts',
    columns: {
      period: 'Periods',
      orderSum: 'Summa',
      status: 'Statuss',
    },
    statuses: {
      Paid: 'Apmaksāts',
      Unpaid: 'Neapmaksāts',
      None: 'Gaida apmaksu',
    },
    subscription: 'Abonements',
    plans: {
      None: 'Nav abonementa',
      Free: 'Bezmaksas',
      Business: 'Bizness',
      BusinessExpired: 'Bizness (beidzies)',
    },
    fields: {
      plan: 'Plāns',
      end: 'Aktīvs līdz',
      card: 'Maksājumu karte',
      nextPayment: 'Nākamais maksājums',
      nextPaymentDate: 'Nākamā maksājuma datums',
      nextPaymentHint:
        'Lai pakalpojums netiktu pārtraukts, maksājums tiek iekasēts katru mēnesi 5 dienas pirms abonementa beigām.',
    },
    warnings: {
      PaymentFailed: 'Automātiskais maksājums neizdevās. Karte: ** {{card}}.',
      NoValidCard: 'Nākamajam maksājumam nav derīgas maksājumu kartes.',
      Expiring: 'Abonements beigsies {{date}}. Pēc tam organizācijas funkcijas nebūs pieejamas.',
    },
    seats: {
      title: 'Lietotāju vietas',
      supervisors: 'Prakses vadītāji',
      admins: 'Administratori',
      allowed: 'Pieejamas',
      assigned: 'Piešķirtas',
      exceeded: 'Piešķirts vairāk nekā pieejams.',
    },
    actions: {
      subscribe: 'Abonēt',
      extend: 'Pievienot vietas',
      unsubscribe: 'Atteikt automātisko atjaunošanu',
    },
    form: {
      subscribeHint:
        'Bāzes paketē ir 1 administrators un 1 prakses vadītājs. Norādiet, cik papildu vietu nepieciešams.',
      extendHint: 'Papildu vietas būs spēkā līdz abonementa beigām — {{date}}.',
      extraUsers: 'Papildu prakses vadītāji',
      extraAdmins: 'Papildu administratori',
      minimum: 'Vismaz {{count}}',
      noSeats: 'Izvēlieties vismaz vienu vietu.',
      total: 'Kopā ar PVN',
      pay: 'Maksāt ar karti',
      buyError: 'Maksājumu neizdevās sākt.',
    },
    cancel: {
      title: 'Atteikt automātisko atjaunošanu?',
      text: 'Abonements netiks atjaunots un beigsies {{date}}. Neapmaksātais nākamā perioda pasūtījums tiks dzēsts.',
      confirm: 'Atteikt',
      done: 'Automātiskā atjaunošana atteikta',
      error: 'Automātisko atjaunošanu neizdevās atteikt.',
    },
  },
  en: {
    settings: 'Settings',
    title: 'Payments',
    history: 'Payment history',
    empty: 'No payments yet.',
    invoice: 'Invoice',
    invoiceError: 'The invoice could not be downloaded.',
    paid: 'Payment received',
    columns: {
      period: 'Period',
      orderSum: 'Amount',
      status: 'Status',
    },
    statuses: {
      Paid: 'Paid',
      Unpaid: 'Unpaid',
      None: 'Awaiting payment',
    },
    subscription: 'Subscription',
    plans: {
      None: 'No subscription',
      Free: 'Free',
      Business: 'Business',
      BusinessExpired: 'Business (expired)',
    },
    fields: {
      plan: 'Plan',
      end: 'Active until',
      card: 'Payment card',
      nextPayment: 'Next payment',
      nextPaymentDate: 'Next payment date',
      nextPaymentHint:
        'To keep the service uninterrupted, the payment is charged every month 5 days before the subscription ends.',
    },
    warnings: {
      PaymentFailed: 'The automatic payment failed. Card: ** {{card}}.',
      NoValidCard: 'There is no valid payment card for the next payment.',
      Expiring:
        'The subscription ends on {{date}}. After that the organization functions will not be available.',
    },
    seats: {
      title: 'User seats',
      supervisors: 'Supervisors',
      admins: 'Administrators',
      allowed: 'Available',
      assigned: 'Assigned',
      exceeded: 'More assigned than available.',
    },
    actions: {
      subscribe: 'Subscribe',
      extend: 'Add seats',
      unsubscribe: 'Cancel automatic renewal',
    },
    form: {
      subscribeHint:
        'The base package includes 1 administrator and 1 supervisor. Choose how many extra seats you need.',
      extendHint: 'The extra seats are valid until the subscription ends — {{date}}.',
      extraUsers: 'Extra supervisors',
      extraAdmins: 'Extra administrators',
      minimum: 'At least {{count}}',
      noSeats: 'Choose at least one seat.',
      total: 'Total incl. VAT',
      pay: 'Pay by card',
      buyError: 'The payment could not be started.',
    },
    cancel: {
      title: 'Cancel automatic renewal?',
      text: 'The subscription will not be renewed and ends on {{date}}. The unpaid order for the next period will be deleted.',
      confirm: 'Cancel renewal',
      done: 'Automatic renewal cancelled',
      error: 'Automatic renewal could not be cancelled.',
    },
  },
}
